/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


export const path: string = 'https://api.fmch.org.mx/api';

export const emulado: boolean = false;
export const remastered: boolean = false;
export const idEmpresa:number = 1;
export const environment = {
  production: false,
  urlServer: 'https://api.fmch.org.mx/api',
  urlServerimg: 'https://api.fmch.org.mx/static/uploads/',
  login: `${path}/login`,
  excelEquipos: `${path}/importEquiposCSV`,
  importFederadosCSV: `${path}/importFederadosCSV`,
  createFederadoUser: `${path}/createFederadoUser`,
  updateFederado: `${path}/updateFederado`,
  getFederadoById: `${path}/getFederadoById`,
  importAsociacionesCSV: `${path}/importAsociacionesCSV`,
  getAllFederadosByEquipo: `${path}/getAllFederadosByEquipo/`,
  genericQuerie: "",

}

/* export const path:string = 'http://localhost:3000/api';
export const environment = {
  production: false,
  urlServer: 'http://localhost:3000/api',
  urlServerimg: 'http://localhost:3000/static/uploads/',
  login: `${path}/login`,
  getAllFederadosByEquipo: `${path}/getAllFederadosByEquipo/`
}; */
